module.exports = __webpack_public_path__ + "components/weather-icon/static/nightmodrain-113bc7f3556be30b82ccef16a95c708a.svg";